import React from 'react';
import { useSelector } from 'react-redux';
import { MegaMenuList } from '@yme/components/Header/Megamenu/MegaMenuList';
import { OfferCards } from '@yme/components/Header/OfferCards/OfferCards';
import { MegamenuStyled } from '@yme/components/Header/styled';
import { getRTL } from '@yme/selectors/common';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { INDENT } from '@yme/tokens/sizes';
export function MenuWithOffers({ navItems, offersModel, label, buttonLabel, menuLink, closeMenuHandler, }) {
    const isRightToLeft = useSelector(getRTL);
    return (React.createElement(MegamenuStyled, { isRightToLeft: isRightToLeft },
        React.createElement(FlexWrapper, { justifyContent: "space-between", height: "100%", gap: "24px", paddingDesktop: isRightToLeft
                ? `${INDENT.sm} 0 ${INDENT.sm} ${INDENT.xl}`
                : `${INDENT.sm} ${INDENT.xl} ${INDENT.sm} 0`, paddingTablet: `${INDENT.xs} ${INDENT.sm} ${INDENT.sm}`, paddingMobile: `${INDENT.xs} ${INDENT.xs} ${INDENT.sm}` },
            React.createElement(MegaMenuList, { navItems: navItems, listTitle: label, menuLink: menuLink, buttonLabel: buttonLabel, isRightToLeft: isRightToLeft, closeMenuHandler: closeMenuHandler }),
            offersModel && (React.createElement(OfferCards, { ...offersModel, closeMenuHandler: closeMenuHandler })))));
}
